module.exports = __webpack_public_path__ + "media/images/category_icons/cafes-a21da473770d01dc0397d6443c538ac7.svg";